import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function setUnregisteredPatientEmail(
  patientUserId: string,
  email: string,
  onBehalfOf?: string,
) {
  const response = await fetchOrchidAPI(
    `/api/users/v1/create_patient/email/${patientUserId}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "PUT",
      body: JSON.stringify({
        email: email,
      }),
    },
  );

  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  return response.json();
}
